<template>
  <div style="height: 100%">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <div class="title">
        <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
        <!-- <h3>角色设置</h3> -->
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="add('add')">新增会员</el-button>
        </div>
      </div>
      <div id="base-list">
        <el-table :data="tableData" :header-cell-style="{
          'text-align': 'left',
          background: '#F8F8F8',
          color: '#333333',
        }">
          <el-table-column prop="goodsName" label="会员名称">
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column label="会员日折扣">
            <template slot-scope="scope">
              {{ scope.row.weeklyDiscount }}折
            </template>
          </el-table-column>
          <el-table-column label="消费积分赠送">
            <template slot-scope="scope">
              {{ scope.row.pointsMulti }}倍
            </template>
          </el-table-column>
          <el-table-column label="返佣比例" width="450px">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;">
                <div style="display: flex;" v-if="scope.row.hasCommission1 == 1">
                  <div style="width: 60px;line-height: 40px;">一级</div>
                  <div><el-input style="width: 80px;" readonly v-model="scope.row.commissionRate1">
                      <div slot="suffix">%</div>
                    </el-input></div>
                </div>
                <div style="display: flex;" v-if="scope.row.hasCommission2 == 1">
                  <div style="width: 60px;line-height: 40px;">二级</div>
                  <div><el-input style="width: 80px;" readonly v-model="scope.row.commissionRate2">
                      <div slot="suffix">%</div>
                    </el-input></div>
                </div>
                <div style="display: flex;" v-if="scope.row.hasCommission3 == 1">
                  <div style="width: 60px;line-height: 40px;">三级</div>
                  <div><el-input style="width: 80px;" readonly v-model="scope.row.commissionRate3">
                      <div slot="suffix">%</div>
                    </el-input></div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="售后天数">
            <template slot-scope="scope">
              {{ scope.row.orderAfterDays }}天
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px">
            <template slot="header">
              <div style="text-align:center">操作</div>
            </template>
            <template slot-scope="scope">
              <div style="text-align: center;margin-left:10px">
                <el-button type="text" size="small" @click="add('edit', scope.row.id)">编辑</el-button>
                <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
          是否确认删除，删除后数据不可恢复！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isD = false">取消</div>
          <div class="info-s" @click="submitD">确定</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      isD: false,
      searchList: {
        list: [
          { title: '会员设置', path: '', type: '0' },
        ]
      },
      dataList: {
        list: [
          { title: '会员管理', path: '', type: '0' },
          { title: '会员设置', path: '', type: '1' }
        ]
      },
      tableData: [

      ],
      id: ''

    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleDelete(row) {
      this.isD = true
      this.id = row.id
    },
    submitD() {
      let ids = []
      ids.push(this.id)
      this.axios.post('/vip/level/deleteByIds', { ids: ids }).then(res => {
        if (res.code == 0) {
          this.getList()
          this.isD = false
        }
      })
    },
    add(type, id) {
      this.$router.push(
        {
          name: 'addOrEditVip',
          query: {
            type: type,
            id: id
          }

        })
    },
    getList() {
      this.axios.get('/vip/level/findUserLevelList').then(res => {
        if (res.code == 0) {
          this.tableData = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-input__suffix {
  top: 8px;
  right: 8%;
  color: #303033;
}

::v-deep .el-tree-node__content {
  display: flex;
  align-items: center;
  height: 55px;
  cursor: pointer;
}

// 自定义图标中隐藏自带箭头
::v-deep .el-tree-node__content>.el-tree-node__expand-icon {
  position: absolute;
  opacity: 0;
}

::v-deep .el-tree-node__content {
  position: relative;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 80px;
}

::v-deep .el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;

  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }

  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}

::v-deep .el-dialog__header {
  text-align: left;
  border-bottom: none;
}

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}

.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

.limits-item {}
</style>

